import * as z from "zod";
import { PAYMENT_METHOD_VALUES } from "@/constants/sales/sales-constants";
import { requiredErrorMessage } from "../common/error-messages";
import { requiredNumberSchema } from "../common/required-number-schema";

export const saleServiceLineSchema = z.object({
  service_id: z.number().min(1, requiredErrorMessage),
  staff_id: z.number().min(1, requiredErrorMessage),
  start_time: z.string().min(1, requiredErrorMessage),
  duration_minutes: z.number().min(1).max(1440),
  price: requiredNumberSchema(
    z.number().min(0).max(999999999).multipleOf(0.01)
  ),
});

export const saleProductLineSchema = z.object({
  product_id: z.number().min(1, requiredErrorMessage),
  staff_id: z.number().min(1, requiredErrorMessage),
  price: requiredNumberSchema(
    z.number().min(0).max(999999999).multipleOf(0.01)
  ),
});

export const salePaymentLineSchema = z.object({
  method: z.enum(PAYMENT_METHOD_VALUES, { error: requiredErrorMessage }),
  amount: requiredNumberSchema(
    z.number().gt(0).max(999999999).multipleOf(0.01)
  ),
});

export const discountPercentSchema = requiredNumberSchema(
  z.number().min(0).max(100).multipleOf(0.01)
);

export const saleCheckoutSchema = z.object({
  discount_percent: discountPercentSchema,
  services: z.array(saleServiceLineSchema).min(1),
  products: z.array(saleProductLineSchema),
  payments: z.array(salePaymentLineSchema).min(1),
});

export type SaleCheckoutFormValues = z.input<typeof saleCheckoutSchema>;
export type SaleCheckoutParsedValues = z.infer<typeof saleCheckoutSchema>;
